export default __webpack_public_path__ + "76c878d37a2bbef366ca4d9b1d0d28fe.webp";